import {Flag} from 'platform/components';
import {Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useAuctionCountdown} from '../../../hooks/useAuctionCountdown';
import {formatAuctionEndDate} from '../utils/formatAuctionEndDate';
import {AuctionCountdown} from './AuctionCountdown';

interface AuctionStatusHeaderProps extends TestIdProps {
  carEndTime?: string | null;
  isEnded: boolean;
}

export function AuctionStatusHeader(props: AuctionStatusHeaderProps) {
  const countdown = useAuctionCountdown(props.carEndTime, props.isEnded);

  return (
    <VStack spacing={2}>
      <HStack justify="space-between" align="center">
        <VStack spacing={1}>
          <Heading size={3} data-testid={suffixTestId('heading', props)}>
            {i18n.t('entity.auction.labels.auction')}
          </Heading>
          <Show when={!countdown.isEnded && countdown.hasEndTime}>
            <Text size="xSmall" color="secondary" data-testid={suffixTestId('endDate', props)}>
              {i18n.t('entity.auction.labels.auctionEndsAt', {
                date: formatAuctionEndDate(props.carEndTime ?? ''),
              })}
            </Text>
          </Show>
          <Show when={countdown.isEnded}>
            <Flag
              label={i18n.t('entity.auction.status.ended')}
              colorScheme="neutral"
              size="small"
            />
          </Show>
        </VStack>
        <Show when={!countdown.isEnded && countdown.hasEndTime}>
          <AuctionCountdown
            days={countdown.days}
            hours={countdown.hours}
            minutes={countdown.minutes}
            seconds={countdown.seconds}
            data-testid={suffixTestId('countdown', props)}
          />
        </Show>
      </HStack>
    </VStack>
  );
}
